// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"5fe3d1ea","573":"974d48a5","574":"a8266372","659":"47437646"}[chunkId] + ".chunk.js";
};